import { useState } from "react";
import "../../../styles/components/elements/textElements/textElementComponent.scss";

const tagMap = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  p: "p",
  span: "span",
  label: "label",
  strong: "strong",
  small: "small",
  div: "div",
};

export const TextElementComponent = ({ props }) => {
  const {
    tag = "p",
    text = "",
    className = "",
    style = {},
    children,
    maxChars = null, // for char-based truncation
    maxLines = null, // for line-clamp truncation
    toggleOnClick = true, // toggle full text on click
    id,
    title,
  } = props;

  const [isExpanded, setIsExpanded] = useState(false);
  const Tag = tagMap[tag] || "p";

  const handleClick = () => {
    if (toggleOnClick && (maxChars || maxLines)) {
      setIsExpanded(!isExpanded);
    }
  };

  const shouldTruncate = !isExpanded && (maxChars || maxLines);
  const displayedText = maxChars && shouldTruncate ? (text.length > maxChars ? `${text.slice(0, maxChars)}...` : text) : text;

  const extraClass = shouldTruncate && maxLines ? "lineClamp" : "";

  return (
    <Tag id={id} className={`textElement ${className} ${extraClass} ${shouldTruncate ? "truncated" : "expanded"}`} style={style} onClick={handleClick} title={title}>
      {children || displayedText}
    </Tag>
  );
};

export default TextElementComponent;
